@if (servicesList | async; as services) {
  @if ((ss.sharing | async).enabled && services.length > 0) {
    <ng-container class="z-share-box">
      <div class="z-share-area z-fx z-fx-gap-8">
        @for (service of services; track service) {
          <mat-icon
            ngClass="z-{{ service.id }}-icon z-share-icon"
            fontSet="zefplayer"
            [style.background-color]="(ss.colors | async).text80"
            [style.color]="(ss.colors | async).mood"
            (click)="onShareSurvey(service)"
          >
            {{ service.icon }}
          </mat-icon>
        }
      </div>
    </ng-container>
  }
}
